import { render, staticRenderFns } from "./TooltipBtn.vue?vue&type=template&id=6484ba30&scoped=true"
import script from "./TooltipBtn.vue?vue&type=script&lang=js"
export * from "./TooltipBtn.vue?vue&type=script&lang=js"
import style0 from "./TooltipBtn.vue?vue&type=style&index=0&id=6484ba30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6484ba30",
  null
  
)

export default component.exports